// with polyfills
import 'core-js/stable';
import 'regenerator-runtime/runtime';

import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import Antd from 'ant-design-vue';

// 引入antd 全局配置
require('@/utils/vant-design-config');
Vue.use(Antd);

// 路由拦截器
require('@/permission');

// 引入全局样式
import '@/assets/css/app.less';
import '@/assets/css/media-mobile.less';
// 全局过滤器
require('@/utils/filter');
// 全局拦截去
import * as request from '@/request/common';
Vue.prototype.$request = request;
// 本地存储
import storage from 'store';
Vue.prototype.$storage = storage;

// IE10以下提示信息
import '@/utils/ie10-tips.js';

// 语言包
import VueI18n from 'vue-i18n';
Vue.use(VueI18n);

import cnLang from './language/cn/index';
import enLang from './language/en/index';
const i18n = new VueI18n({
    //定义默认语言
    locale: 'cn',
    messages: {
        cn: cnLang,
        en: enLang
    }
});

window.$i18n = i18n;
Vue.config.productionTip = false;
Vue.config.ignoredElements = ['wx-open-launch-weapp'];

// 引入hotcss
import 'amfe-flexible/index.js';

// 引入剪切插件
import VueClipboard from 'vue-clipboard2';
Vue.use(VueClipboard);

new Vue({
    router,
    store,
    i18n,
    render: h => h(App)
}).$mount('#app');
